<div
    #tooltipText
    class="overflow-text"
    [nz-tooltip]="text?text:''"
    [nzTooltipOverlayStyle]="text?.length > maxLength ? {} : { display: 'none' }"
    [innerHTML]="isMemberEnabled() ? showText : showText + ' (Inactive)'"
></div>
